import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { RefreshCw, Shield } from 'lucide-react';

import { BACKEND_URL } from '../config';

const MathCaptcha = ({ onCaptchaChange, error }) => {
  const [captchaQuestion, setCaptchaQuestion] = useState('');
  const [captchaId, setCaptchaId] = useState('');
  const [userAnswer, setUserAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchCaptcha = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${BACKEND_URL}/api/captcha/generate`);
      setCaptchaQuestion(response.data.question);
      setCaptchaId(response.data.captchaId);
      setUserAnswer('');
      // Notify parent component
      onCaptchaChange(response.data.captchaId, '');
    } catch (err) {
      console.error('Error fetching CAPTCHA:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const handleAnswerChange = (e) => {
    const answer = e.target.value;
    setUserAnswer(answer);
    // Notify parent component
    onCaptchaChange(captchaId, answer);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        Security Verification
      </label>
      <div className="bg-gray-50 border border-gray-300 rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <Shield className="w-5 h-5 text-[#0d6571]" />
          <span className="text-sm font-medium text-gray-700">
            Solve: {captchaQuestion} = ?
          </span>
          
          {/* Refresh Button - Mobile Friendly */}
          <button
            type="button"
            onClick={fetchCaptcha}
            disabled={loading}
            className="ml-auto flex-shrink-0 p-2 bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors disabled:opacity-50"
            title="Generate new question"
          >
            <RefreshCw className={`w-4 h-4 text-gray-700 ${loading ? 'animate-spin' : ''}`} />
          </button>
        </div>
        
        {/* Answer Input - Full Width */}
        <input
          type="number"
          value={userAnswer}
          onChange={handleAnswerChange}
          placeholder="Enter your answer"
          className={`w-full px-4 py-3 border-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0d6571] focus:border-transparent transition-all ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
          disabled={loading}
          required
        />

        {error && (
          <p className="mt-2 text-sm text-red-600">{error}</p>
        )}
        
        <p className="mt-2 text-xs text-gray-500">
          This helps us prevent automated bots.
        </p>
      </div>
    </div>
  );
};

export default MathCaptcha;
